export default "__VITE_ASSET__Clwl$P30__"